import type { Locale } from './use-current-locale';

/**
 * Cross-entity JSONB-i18n contract: backend stores `{ru, en, uz}` maps in `jsonb`
 * columns for any user-facing string (category.name, product.name/description, …).
 */
export type LocalizedString = Record<Locale, string>;

/**
 * Resolve a localized string with graceful fallback: current locale → en → ru → uz → fallback.
 * Empty strings count as "missing" so partially-translated rows still render something useful.
 */
export function pickLocalized(
  map: LocalizedString | null | undefined,
  locale: Locale,
  fallback = '',
): string {
  if (!map) return fallback;
  return map[locale] || map.en || map.ru || map.uz || fallback;
}
